<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="aliasForm">
		<div class="grid">
			<div class="col-12" *ngFor="let command of commands">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f[command.Name], 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[command.Name], 'label')">{{ command.Default | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[command.Name], 'borderInput')">
						<input type="text" pInputText [class]="onExtendedMobile() ? 'pl-6' : ''"
							[ngClass]="dynamicInputTextWidth()" [formControlName]="command.Name"
							placeholder="{{ command.Name }}" maxlength="50" />
						<p-button pTooltip="{{ 'RESTORE_DEFAULT' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
							styleClass="p-1" (click)="restoreDefault(command.Name)" [rounded]="false" [text]="true"
							severity="danger">
						</p-button>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f[command.Name])" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_NAME' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>